export const validateField = (name, value) => {
    if (!value.trim()) {
      return false;
    }
    // Add other validation logic based on the field name, if necessary
    return true;
  };


export const formatPhoneNumber = (value) => {
    if (!value) return value;

    // Remove all non-digits, then truncate to 10 digits
    const phoneNumber = value.replace(/[^\d]/g, '').slice(0, 10);

    // Break the string into parts to format with dashes
    const parts = [];
    if (phoneNumber.length > 3) {
      parts.push(phoneNumber.slice(0, 3));
      if (phoneNumber.length >= 6) {
        parts.push(phoneNumber.slice(3, 6));
        parts.push(phoneNumber.slice(6, 10));
      } else {
        parts.push(phoneNumber.slice(3));
      }
    } else {
      parts.push(phoneNumber);
    }
    return parts.filter(part => part).join('-');
};


export const formatDollarWithComma = (value) => {
    if (!value) return '';

    // Remove any non-digit characters except the dot (.) for decimals
    const cleanValue = value.replace(/[^\d.]/g, '');
    
    let [whole, decimal] = cleanValue.split('.');
    
    // Format the whole number with commas
    let formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    // Reassemble the formatted whole number and decimal parts
    if (decimal !== undefined) {
      formattedWhole += '.' + decimal;
    }

    return formattedWhole;
};

export const formatDate = (date) => {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
};

export const calculateSkippedSteps = (selectedOption) => {
  switch (selectedOption) {
      case 'Plan on getting location':
          return [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
      case 'No location / virtual location':
        return [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
      default:
          return [7];
  }
};

export const findNextUnskippedStep = (currentStep, skippedSteps) => {
  let nextStep = currentStep + 1;
  while (skippedSteps.includes(nextStep)) {
    nextStep += 1;
  }
  return nextStep;
};

/** Today as `YYYY-MM-DD` — the `min` for a date field that may not be in the past. */
export const todayDateString = () => formatDate(new Date());

/**
 * `YYYY-MM-DD` for a number of days from today. Uses Date arithmetic so the
 * month and the year roll over (getDate() + 1 on the last of the month used to
 * produce an out-of-range string, which browsers then ignore as a `min`).
 */
export const dateStringInDays = (days) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return formatDate(date);
};

/**
 * The earliest date a start date field offers. Normally today — but a record saved
 * earlier can already hold a past date, and that one stays selectable so the record
 * can still be edited.
 */
export const earliestStartDate = (currentValue) =>
    (isDateBefore(currentValue) ? currentValue : todayDateString());

/** True when a `YYYY-MM-DD` value is filled in and falls before `minDate`. */
export const isDateBefore = (value, minDate = todayDateString()) => !!value && value < minDate;

/**
 * A Cost Center ID carries one segment per organisation level, the way the branch
 * records hold it: S<satellite>B<branch>R<region>D<division>, e.g. S10300B103R00D10.
 */
export const COST_CENTER_ID_PATTERN = /^S\d+B\d+R\d+D\d+$/i;

export const isValidCostCenterId = (value) => COST_CENTER_ID_PATTERN.test(String(value ?? '').trim());

// The API returns file paths that can be null, undefined or the literal string
// "null" for slots that were never uploaded. Rendering those directly used to
// crash the whole page ("Cannot read properties of null (reading 'split')"),
// so every file name is read through these two helpers.
export const getFileName = (path) => {
    if (path === null || path === undefined) return '';

    const value = String(path).trim();
    if (!value || value === 'null' || value === 'undefined') return '';

    return value.split('/').pop();
};

export const toFileList = (value) => {
    if (!Array.isArray(value)) return [];

    return value.filter((item) => getFileName(item));
};
